export class FilterItems {
    Skip: number;
    Take: number;
    SearchText: string;
    SortKey: string;
    IsDesc: boolean;

    constructor() {
        this.Skip = 0;
        this.Take = 0;
        this.SearchText = '';
        this.SortKey = '';
        this.IsDesc = false;
    }
}
